import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import classes from "./MessagingStatusLabel.module.css";

const MessagingStatusLabel = (props) => {
  const { text, isValid } = props;

  return (
    <span className={classes.statusLabel}>
        {isValid ?
            <CheckCircleOutlineOutlinedIcon sx={{marginRight: '5px'}} color="success" /> : 
            <CancelOutlinedIcon sx={{marginRight: '5px'}} color="error" />
        }
        {text} 
    </span>
  )
};

export default MessagingStatusLabel;